import { Loading3QuartersOutlined } from "@ant-design/icons";
import styles from "./LoadingView.module.scss";

type Props = {
  message?: string;
  hideLoader?: boolean;
};

const LoadingView: React.FC<Props> = ({ message, hideLoader }) => {
  return (
    <div className={styles.root}>
      {Boolean(message) && <h4>{message}</h4>}
      {!hideLoader && (
        <Loading3QuartersOutlined spin className={styles.loader} />
      )}
    </div>
  );
};

export default LoadingView;
